import { render, staticRenderFns } from "./DetailAssistance.vue?vue&type=template&id=a632cea4&scoped=true"
import script from "./DetailAssistance.vue?vue&type=script&lang=ts"
export * from "./DetailAssistance.vue?vue&type=script&lang=ts"
import style0 from "./DetailAssistance.vue?vue&type=style&index=0&id=a632cea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a632cea4",
  null
  
)

export default component.exports